import ProductFilteringRouterWrap from 'Vue/containers/ProductFilteringRouterWrap.vue';

// @ts-ignore
import { createApp } from 'vue';
import store from 'Store/index';
import router from 'Router/index';
import Toast, { PluginOptions } from 'vue-toastification';
// @ts-ignore
import PerfectScrollbar from 'vue3-perfect-scrollbar';

let module: any = {};

/**
 * Instantiate Vue Application
 */
module.addVueApp = function () {
    const options: PluginOptions = {
        transition: 'Vue-Toastification__bounce',
        maxToasts: 20,
        newestOnTop: true,
    };

    const products = createApp(ProductFilteringRouterWrap).use(store).use(Toast, options).use(PerfectScrollbar).use(router);
    products.mount('#productFiltering');
};

module.init = function () {
    module.addVueApp();
};

document.addEventListener('DOMContentLoaded', () => {
    module.init();
});
